import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { DialogConfig } from '../../../shared/configs/dialog.config';
import { PurchaseOrderShipmentsFormComponent } from '../purchase-order-shipments-form/purchase-order-shipments-form.component';

@Component({
  selector: 'lum-purchase-order-shipments',
  templateUrl: './purchase-order-shipments.component.html',
  styleUrls: ['./purchase-order-shipments.component.scss'],
})
export class PurchaseOrderShipmentsComponent implements OnInit, OnDestroy {
  @Input() add$ :Observable<void>;

  #onDestroy$ = new Subject<void>();

  constructor(private dialog :MatDialog) {}

  ngOnInit() :void {
    this.#initAddHandler();
  }

  ngOnDestroy() :void {
    this.#onDestroy$.next();
    this.#onDestroy$.complete();
  }

  #addShipment() {
    this.dialog.open(PurchaseOrderShipmentsFormComponent, {
      ...DialogConfig.LARGE,
    });
  }

  #initAddHandler() {
    if (this.add$ && this.add$ instanceof Observable) {
      this.add$.pipe(takeUntil(this.#onDestroy$)).subscribe(() => {
        this.#addShipment();
      });
    }
  }
}
